/** Thrown from route `beforeLoad` when the authenticated user lacks the required role. */
export class ForbiddenError extends Error {
  constructor(message = 'You do not have permission to access this page.') {
    super(message);
    this.name = 'ForbiddenError';
  }
}
